<script lang="ts">
    import { spineBus } from '$lib/services/gatekeeper/MessageBus';
    import { browser } from '$app/environment';

    const SEON_AGENT_URL_V6 = 'https://cdn.seondf.com/js/v6/agent.umd.js';

    const injectScript = (src: string) =>
        new Promise<void>((resolve, reject) => {
            const script = document.createElement('script');

            script.onload = () => resolve();
            script.onerror = () => reject(`Script url, failed to load`);
            script.src = src;
            script.defer = true;

            if (document.head) {
                document.head.appendChild(script);
            }
        });

    // Flow described in documentation https://docs.seon.io/api-reference/fraud-api#javascript-agent-v6
    const injectSeon = async () => {
        try {
            await injectScript(SEON_AGENT_URL_V6);
            if (window.seon) {
                await window.seon.init();
                spineBus.publish('external', { kind: 'on-seon-loaded', loaded: true });
            } else {
                console.error(`Seon init error`);
                spineBus.publish('external', { kind: 'on-seon-loaded', loaded: false });
            }
        } catch {
            console.error(`Seon injection error`);
            spineBus.publish('external', { kind: 'on-seon-loaded', loaded: false });
        }
    };

    if (browser && !window.seon) {
        injectSeon();
    }
</script>
